import React from 'react';
import ProductTile from '../../localcontent/yourtitles/ProductTile';
import { createLibxchangeProductDetailLink } from '../../localcontent/yourtitles/utils/product-detail-link-helpers';
import ListItem from '../../localcontent/yourtitles/ListItem';
import { UseMutateFunction } from '@tanstack/react-query';
import { ProductMetaData } from '../../../../models/Product';
import { DISPLAY_TYPE_LIST, DisplayType } from '../../../shared/common/displayType/types';

interface Props {
    displayType: DisplayType;
    onAddToCollection: UseMutateFunction<void, unknown, string, unknown>;
    product: ProductMetaData;
    hoverListener?: (isHover: boolean) => void;
    minimalView: boolean;
    shopLanguage: string | undefined;
}

const LibxchangeProductElement = ({
    product,
    displayType,
    onAddToCollection,
    hoverListener,
    minimalView,
    shopLanguage
}: Props) => {
    const productLinkUri = createLibxchangeProductDetailLink(product.id);

    if (displayType === DISPLAY_TYPE_LIST) {
        return (
            <ListItem
                isYourTitle={false}
                isLibxchange={true}
                isInCollection={false}
                productLinkUri={productLinkUri}
                product={product}
                onAddToCollection={onAddToCollection}
                shopLanguage={shopLanguage}
            />
        );
    }

    return (
        <ProductTile
            isYourTitle={false}
            isLibxchange={true}
            isInCollection={false}
            productLinkUri={productLinkUri}
            shopLanguage={shopLanguage}
            product={product}
            hoverListener={hoverListener}
            onAddToCollection={onAddToCollection}
            minimalView={minimalView}
        />
    );
};

export default LibxchangeProductElement;
